module.exports = __webpack_public_path__ + "img/nexultra-UV.ee9ca68a.jpg";